import styles from "./custom-progress-indicator.module.scss";

const CustomProgressIndicator = ({ label = "Progreso", percentage = 0, variant = "primary", onClick = null, size = "md" }) => {
	const isClickable = typeof onClick === "function";

	const handleClick = () => {
		if (isClickable) {
			onClick();
		}
	};

	const handleKeyDown = (e) => {
		if (isClickable && (e.key === "Enter" || e.key === " ")) {
			e.preventDefault();
			onClick();
		}
	};

	return (
		<div
			className={`${styles.indicator} ${styles[variant]} ${styles[size]} ${isClickable ? styles.clickable : ""}`}
			onClick={isClickable ? handleClick : undefined}
			onKeyDown={isClickable ? handleKeyDown : undefined}
			role={isClickable ? "button" : undefined}
			tabIndex={isClickable ? 0 : undefined}
		>
			<div className={styles.content}>
				<span className={styles.label}>{label}</span>
				<span className={styles.percentage}>{percentage.toFixed(1)}%</span>
			</div>

			<div className={styles.progressBar}>
				<div className={styles.progressFill} style={{ width: `${Math.min(percentage, 100)}%` }} />
			</div>
		</div>
	);
};

export default CustomProgressIndicator;
